// "use strict";

window.State = (function () {
  function State(dom_element) {
    var _this = this;

    this.dom_element = dom_element;

    this.data = undefined;

    this.test = function () {
      alert('parent');
    };

    function boot() {
      if (_.isEmpty(this.dom_element.id)) {
        var randomid = 'generated_id_' + Math.floor(Math.random() * 100000 + 1);
        this.dom_element.id = randomid;
        Object.defineProperty(this.dom_element, 'id', {
          value: randomid,
          writable: false,
        });
      }
      if (typeof State.instances[this.dom_element.id] !== 'undefined') {
        // console.log('Warning: a State object has already been created for this node');
        return;
      }

      State.instances[this.dom_element.id] = this;

      this._parent = _.cloneDeep(this);

      this.provider = _.find(State.serviceProviders, function (r) {
        return r.test(_this.dom_element);
      });

      _.assign(this, new this.provider.Provider());

      this.data = this.get_data();

      $('#' + this.dom_element.id).on(this.event_name, this.handler.bind(this));
    } // close boot()

    this.trigger = function (event_name, args) {
      var e = {
        type: 'state:' + event_name,
        event_arguments: args,
        stateObject: this,
      };
      $.event.trigger(e);
    };

    this.update = function (data) {
      this.data = data;
    };

    this.handler = function () {
      this.update(this.get_data());
      this.trigger.call(this, 'updated', arguments);
    };

    boot.bind(this)();
  } // close State class

  State.instances = {};

  State.serviceProviders = [
    {
      label: 'JsTree Provider',
      test: function (dom_element) {
        return $(dom_element).jstree(true) !== false;
      },
      Provider: function () {
        this.event_name = 'changed.jstree';

        this.get_data = function () {
          return $(this.dom_element).jstree('get_json');
        };
      },
    },
    {
      label: 'Select Provider',
      test: function (dom_element) {
        return $(dom_element).is('select');
      },
      Provider: function () {
        this.event_name = 'change';

        this.get_data = function () {
          return $(this.dom_element).val();
        };

        this.handler = function () {
          this.update(this.get_data());
        };
      },
    },
    {
      label: 'Button Provider',
      test: function (dom_element) {
        return $(dom_element).is('button');
      },
      Provider: function () {
        this.event_name = 'click';
      },
    },
    {
      label: 'DOM Provider',
      test: function (dom_element) {
        return $(dom_element).length;
      },
      Provider: function () {
        this.event_name = 'click';

        this.get_data = function () {
          return $(this.dom_element);
        };
      },
    },
  ];

  //   return function(){}
  return State;
})();

$(document).on('state:updated', function (e) {
  var identifier =
    e.stateObject.dom_element.id ||
    (function () {
      throw new Error('No id is present on the dom node provided');
    })();
  var callbacks = _.filter(special_circumstances[identifier], function (r) {
    return r.test.bind(e.stateObject)(e);
  });
  for (var i = 0; i < callbacks.length; i++) {
    if (callbacks[i].callback(e) === false) break; // return false from the callback to break out
  }
});

var special_circumstances = {};

special_circumstances['lstCharLabels'] = [
  {
    label: 'Is Region selected?',
    test: function (e) {
      const regionCharLabel = _.find(this.data, { text: trans('Region') });
      const regionSelected = regionCharLabel.state.selected;
      // Need to account for some subregions being selected, which doesn't count as region being selected
      let subRegionSelected = false;
      for (let subRegion of regionCharLabel.children) {
        if (subRegion.state.selected) {
          subRegionSelected = true;
          break;
        }
      }
      return regionSelected || subRegionSelected;
    },
    callback: function (e) {
      $('[data-value="SurveyChar"]').click();
      $('#PivotOption1, #PivotOption2').attr('disabled', 'disabled');
    },
  },

  {
    label: 'Is this Total?',
    test: function (e) {
      return !!_.find(this.data, { text: 'Total', state: { selected: true } });
    },
    callback: function (e) {
      // console.log('total is selected')
    },
  },

  {
    label: 'Is Region NOT selected?',
    test: function (e) {
      const regionCharLabel = _.find(this.data, { text: trans('Region') });
      const regionSelected = regionCharLabel.state.selected;
      // Need to account for some subregions being selected, which doesn't count as region being selected
      let subRegionSelected = false;
      for (let subRegion of regionCharLabel.children) {
        if (subRegion.state.selected) {
          subRegionSelected = true;
          break;
        }
      }
      return !regionSelected && !subRegionSelected;
    },
    callback: function (e) {
      $('#PivotOption1, #PivotOption2').removeAttr('disabled');
    },
  },
];

(function ($) {
  if (typeof $.fn.tree_value !== 'undefined') return;
  $.fn.tree_value = function () {
    if (_.isEmpty(arguments)) throw new Error('Supply text to search for to tree_value');

    var _this = this;
    _this.arguments = arguments;

    return new Promise(function (resolve, reject) {
      var intid = setInterval(function () {
        var $tree = _this.jstree(true);
        if ($tree === false) return;

        var tree_data = $tree.get_json();
        if (_.isEmpty(tree_data)) return;

        clearInterval(intid);

        var args = _this.arguments[0].split(':');
        var element_collection = [];
        var node_obj = _.find(tree_data, { text: args[0] }) || {};
        var $node_obj = $tree.get_node(node_obj.id, true);
        if (node_obj && $node_obj.length) element_collection.push($node_obj[0]);
        if (args.length > 1) {
          // now look in children
          var node_obj2 = _.find(node_obj.children, { text: args[1] }) || {};
          var $node_obj2 = $tree.get_node(node_obj2.id, true);
          if (node_obj2 && $node_obj2.length) element_collection.push($node_obj2[0]);
        }

        resolve($(element_collection));
      }, 100);
    });
  };
})(jQuery);
